import React, { useState, useEffect, useRef } from "react";
import classNames from "classnames";
import { Link } from "react-router-dom";
import { getOverallSettingsClasses } from "../../utils/siteUtils";
import { mobileIs } from "../../utils/siteUtils";
import MobileNavMenu from "../../sections/mobile-nav-menu"
import "./style.scss";
import { gtag } from "../../utils";

const NewsHeader = props => {
	const { lang, rendering, fields, page } = props;
  const {	list, logo, logo_link } = fields;
  const isMobile = mobileIs()
  const isAR = page?.fields?.rtl?.value;
  const rootNode = useRef()
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  useEffect(() => {
  	 
  }, [])

  const Logo = ({ src, alt, title, onClick, lang }) => (
    <div onClick={onClick}>
      <img src={src} alt={alt} className="logo" title={title} />
    </div>
  );

  const logoFn = () => {
    gtag('event', 'Component_info', {
      'component_name': 'NewsHeader',
      'page_title': page?.name
    });
    setIsMenuOpen(false)
    let a = document.createElement('a')
    a.setAttribute('target', '_blank')
    a.setAttribute('href', logo_link?.value?.href)
    document.body.appendChild(a)
    a.click()
  }

  const rootClasses = classNames("c-news-header", getOverallSettingsClasses(fields));
  return (
    <div className={rootClasses} datasourceid={rendering.dataSource} ref={rootNode}>
      {isMobile && <MobileNavMenu
        {...{
          page,
          isAR,
          menuItems: list,
          setIsMenuOpen: setIsMenuOpen
        }}
        show={isMenuOpen}
      />}
      {isMenuOpen && isMobile && <div className="header-cover"></div>}
      <div className="logo">
        <Logo {...logo.value} onClick={logoFn} lang={lang} />
      </div>
      <div className="menu-items">
        {list && list.map((item, index) => (
          <Link to={item.fields.link.value.href} key={index} className={["menu", (item.fields.link.value.id.toLowerCase()).indexOf(page.itemId) === -1 ? '' : 'active1'].join(' ')}>
            { item.fields.link.value.text }
          </Link>
        ))}
      </div>
    </div>
  );
};

export default 	NewsHeader;